import React from "react";
import styles from "./IconMessage.module.css";

export function IconMessage({
  icon,
  caption,
}: React.PropsWithChildren<{ icon: string; caption?: string }>) {
  return (
    <div className={styles.iconMessageContainer}>
      <i className={`narmi-icon-${icon} fontSize--heading0`} />
      <div className="margin--top--m">{caption}</div>
    </div>
  );
}
